/* Setosa core behaviours. Shared by every setosa-* section.

   Owns: countdowns, PDP gallery carousels, quantity steppers, variant pills
   and the sticky mobile buy bar.

   Replaces the three separate countdown scripts that used to live in
   setosa-product.js, setosa-bundle.liquid and setosa-collection.liquid, plus
   the duplicated carousel/qty/sticky logic in setosa-product.js and the
   inline script in setosa-bundle.liquid. */
(function () {
  if (window.__setosaCore) return;
  window.__setosaCore = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function all(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------- countdown */

  function initCountdowns() {
    var timers = [];
    all('[data-setosa-cd]').forEach(function (el) {
      if (el.__setosaCd) return;
      var dl;
      var hoursAttr = el.getAttribute('data-hours');
      if (hoursAttr) {
        /* Rolling countdown: full length again on every page load/visit, no persistence. */
        dl = Date.now() + parseFloat(hoursAttr) * 3600000;
      } else {
        dl = new Date(el.getAttribute('data-deadline')).getTime();
      }
      if (isNaN(dl)) return;
      el.__setosaCd = true;
      timers.push({
        el: el, deadline: dl,
        d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'),
        m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]')
      });
    });
    if (!timers.length) return;

    var iv;
    function tick() {
      var now = Date.now(), live = 0;
      timers.forEach(function (t) {
        if (t.done) return;
        var left = t.deadline - now;
        if (left <= 0) { t.done = true; t.el.setAttribute('hidden', ''); return; }
        live++;
        if (t.d) t.d.textContent = pad(Math.floor(left / 86400000));
        if (t.h) t.h.textContent = pad(Math.floor(left / 3600000) % 24);
        if (t.m) t.m.textContent = pad(Math.floor(left / 60000) % 60);
        if (t.s) t.s.textContent = pad(Math.floor(left / 1000) % 60);
      });
      if (!live && iv) clearInterval(iv);
    }
    tick();
    iv = setInterval(tick, 1000);
  }

  /* ----------------------------------------------------------------- carousel */

  function initCarousels() {
    all('[role="region"][aria-roledescription="carousel"]').forEach(function (region) {
      if (region.__setosaCarousel) return;
      var track = region.querySelector('[data-setosa-track]');
      if (!track) return;
      region.__setosaCarousel = true;

      var slides = track.children;
      var dotsWrap = region.querySelector('[data-setosa-dots]');

      function step() {
        if (!slides.length) return 0;
        var gap = parseFloat(getComputedStyle(track).columnGap || 0) || 0;
        return slides[0].getBoundingClientRect().width + gap;
      }
      function go(dir) {
        track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
      }

      var prev = region.querySelector('[data-setosa-prev]');
      var next = region.querySelector('[data-setosa-next]');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      if (dotsWrap && slides.length > 1) {
        for (var i = 0; i < slides.length; i++) {
          (function (i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Go to image ' + (i + 1));
            b.addEventListener('click', function () {
              track.scrollTo({ left: i * step(), behavior: reduce ? 'auto' : 'smooth' });
            });
            dotsWrap.appendChild(b);
          })(i);
        }
        var ticking = false;
        function mark() {
          var idx = Math.round(track.scrollLeft / (step() || 1)) || 0;
          [].forEach.call(dotsWrap.children, function (d, j) {
            d.setAttribute('aria-current', j === idx ? 'true' : 'false');
          });
          ticking = false;
        }
        track.addEventListener('scroll', function () {
          if (!ticking) { ticking = true; requestAnimationFrame(mark); }
        }, { passive: true });
        mark();
      }
    });
  }

  /* -------------------------------------------------------------- quantity */

  function initQty() {
    all('[data-setosa-qty]').forEach(function (input) {
      if (input.__setosaQty) return;
      input.__setosaQty = true;
      var box = input.closest('.setosa-qty') || input.parentElement;
      var minus = box.querySelector('[data-setosa-minus]');
      var plus = box.querySelector('[data-setosa-plus]');
      if (minus) minus.addEventListener('click', function () {
        var n = parseInt(input.value, 10) || 1;
        if (n > 1) input.value = n - 1;
      });
      if (plus) plus.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  /* ----------------------------------------------------------------- packs */

  function initPacks() {
    all('[data-setosa-packs]').forEach(function (wrap) {
      if (wrap.__setosaPacks) return;
      wrap.__setosaPacks = true;
      var form = wrap.closest('form');
      var qty = form && form.querySelector('[data-setosa-qty]');
      if (!qty) return;
      var packs = all('[data-setosa-pack]', wrap);

      var box = wrap.closest('[data-setosa-buybox]') || document;
      var priceEl = box.querySelector('[data-setosa-price]');
      var compareEl = box.querySelector('[data-setosa-compare]');
      var saveEl = box.querySelector('[data-setosa-save]');
      var stickyEl = document.querySelector('[data-setosa-stickyprice]');
      var base = {
        price: priceEl && priceEl.textContent,
        compare: compareEl && compareEl.textContent,
        save: saveEl && saveEl.textContent
      };

      /* Price block and sticky bar follow the chosen pack. A quantity that does
         not match a box (4, 5, ...) falls back to the single price. */
      function mark() {
        var n = parseInt(qty.value, 10) || 1;
        var hit = null;
        packs.forEach(function (b) {
          var on = parseInt(b.getAttribute('data-setosa-pack'), 10) === n;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          if (on) hit = b;
        });
      }
      packs.forEach(function (b) {
        b.addEventListener('click', function () {
          qty.value = b.getAttribute('data-setosa-pack');
          qty.dispatchEvent(new Event('change', { bubbles: true }));
          mark();
        });
      });
      /* Keep the boxes in step with the stepper and manual typing. */
      form.addEventListener('click', function (e) {
        if (e.target.closest('[data-setosa-minus],[data-setosa-plus]')) setTimeout(mark, 0);
      });
      qty.addEventListener('input', mark);
      qty.addEventListener('change', mark);
      mark();
    });
  }

  /* ------------------------------------------------------- price by quantity */

  /* One renderer for the price block: unit price (of the selected variant) x quantity,
     less the Buy 2 / Buy 3 discount when the page shows pack boxes. Runs on the stepper,
     typing, pack boxes and variant changes, and keeps the struck price, the "You save"
     line and the sticky bar in step. */
  function initQtyPrice() {
    all('[data-setosa-buybox]').forEach(function (box) {
      if (box.__setosaRender) return;
      var form = box.querySelector('form');
      var qty = form && form.querySelector('[data-setosa-qty]');
      var priceEl = box.querySelector('[data-setosa-price]');
      if (!qty || !priceEl) return;
      var compareEl = box.querySelector('[data-setosa-compare]');
      var saveEl = box.querySelector('[data-setosa-save]');
      var select = box.querySelector('[data-setosa-id]');
      var sticky = document.querySelector('[data-setosa-stickyprice]');
      var off2 = parseInt(box.getAttribute('data-off2'), 10) || 0;
      var off3 = parseInt(box.getAttribute('data-off3'), 10) || 0;

      /* Reuse the store's own formatting: whatever surrounds the digits in the first price. */
      var sample = priceEl.textContent.trim();
      var prefix = sample.replace(/[0-9].*$/, '');
      var suffix = sample.replace(/^.*[0-9]/, '');
      function money(cents) { return prefix + Math.round(cents / 100).toLocaleString('en-US') + suffix; }

      function render() {
        var n = Math.max(1, parseInt(qty.value, 10) || 1);
        var opt = select && select.options[select.selectedIndex];
        var unit = parseInt(opt ? opt.getAttribute('data-cents') : box.getAttribute('data-unit'), 10);
        var cmp = parseInt(opt ? opt.getAttribute('data-compare-cents') : box.getAttribute('data-unit-compare'), 10) || 0;
        if (!unit) return;
        var off = n >= 3 ? off3 : (n === 2 ? off2 : 0);
        var total = Math.floor(unit * n * (100 - off) / 100);
        var was = (cmp > unit ? cmp : unit) * n;
        var hasWas = was > total;
        priceEl.textContent = money(total);
        if (compareEl) {
          if (hasWas) { compareEl.textContent = money(was); compareEl.removeAttribute('hidden'); }
          else compareEl.setAttribute('hidden', '');
        }
        if (saveEl) {
          if (hasWas) { saveEl.textContent = 'You save ' + money(was - total); saveEl.removeAttribute('hidden'); }
          else saveEl.setAttribute('hidden', '');
        }
        if (sticky) sticky.textContent = money(total);
      }

      box.__setosaRender = render;
      qty.addEventListener('input', render);
      qty.addEventListener('change', render);
      form.addEventListener('click', function (e) {
        if (e.target.closest('[data-setosa-minus],[data-setosa-plus],[data-setosa-pack]')) setTimeout(render, 0);
      });
      render();
    });
  }

  /* -------------------------------------------------------------- variants */

  function initVariants() {
    all('[data-setosa-buybox]').forEach(function (box) {
      if (box.__setosaVariants) return;
      var select = box.querySelector('[data-setosa-id]');
      if (!select) return;
      box.__setosaVariants = true;

      var pills = all('[data-setosa-opt]', box);
      var priceEl = box.querySelector('[data-setosa-price]');
      var compareEl = box.querySelector('[data-setosa-compare]');
      var addBtn = box.querySelector('[data-setosa-add]');
      var addText = box.querySelector('[data-setosa-addtext]');

      function sync() {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        if (priceEl) priceEl.textContent = opt.getAttribute('data-price') || priceEl.textContent;
        var cmp = opt.getAttribute('data-compare');
        if (compareEl) {
          if (cmp && cmp !== '' && cmp !== opt.getAttribute('data-price')) {
            compareEl.textContent = cmp;
            compareEl.removeAttribute('hidden');
          } else {
            compareEl.setAttribute('hidden', '');
          }
        }
        if (box.__setosaRender) box.__setosaRender();
        var available = opt.getAttribute('data-available') === 'true';
        if (addBtn) addBtn.disabled = !available;
        if (addText) addText.textContent = available
          ? (addBtn.getAttribute('data-cta') || addText.textContent)
          : 'Sold Out';
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var val = pill.getAttribute('data-setosa-value');
          var group = pill.closest('.setosa-opt__pills');
          if (group) all('.setosa-pill', group).forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');

          var label = pill.closest('.setosa-opt').querySelector('[data-setosa-optval]');
          if (label) label.textContent = val;

          // Build the wanted option set, then find the matching variant.
          var wanted = all('.setosa-opt', box).map(function (o) {
            var active = o.querySelector('.setosa-pill.is-active');
            return active ? active.getAttribute('data-setosa-value') : null;
          });
          for (var i = 0; i < select.options.length; i++) {
            var title = select.options[i].textContent.trim();
            var parts = title.split(' / ').map(function (s) { return s.trim(); });
            var match = wanted.every(function (w, k) { return w === null || parts[k] === w; });
            if (match) { select.selectedIndex = i; break; }
          }
          select.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
        });
      });

      select.addEventListener('change', sync);
      sync();
    });
  }

  /* -------------------------------------------------------- app widget move */

  /* Quantity-break / free-gift apps (BOGOS etc.) inject their own picker as a
     direct child of .setosa-buy, between the quantity stepper and the submit
     button, the moment their script runs. We want that picker to visually
     sit BELOW the Add to Cart / Buy it now buttons instead. Rather than fight
     the app's own insertion logic, let it inject where it wants, then move
     the node it added to right after .setosa-dyn (the dynamic checkout
     button, the last thing in the form). A MutationObserver catches the
     insertion whenever it happens, since these apps don't all run at the
     same point in the page lifecycle. */

  function initBuyWidgetReposition() {
    all('.setosa-buy').forEach(function (buyBox) {
      if (buyBox.__setosaReposition) return;
      buyBox.__setosaReposition = true;

      var form = buyBox.closest('form');
      var dyn = form ? form.querySelector('[data-setosa-dyn]') : null;
      if (!dyn) return;

      function relocate(node) {
        if (node.nodeType !== 1) return;
        if (node.classList.contains('setosa-qty') || node.classList.contains('setosa-add')) return;
        if (node.__setosaRelocated) return;
        node.__setosaRelocated = true;
        /* Our own Buy 1 / 2 / 3 boxes replace the app's tier list. */
        if (form.querySelector('[data-setosa-packs]') && node.tagName !== 'INPUT' && node.type !== 'hidden') { node.style.display = 'none'; return; }
        dyn.insertAdjacentElement('afterend', node);
      }

      all(':scope > *', buyBox).forEach(relocate);

      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          [].forEach.call(m.addedNodes, relocate);
        });
      }).observe(buyBox, { childList: true });
    });
  }

  /* ---------------------------------------------------------------- sticky */

  function initSticky() {
    all('[data-setosa-sticky]').forEach(function (sticky) {
      if (sticky.__setosaSticky) return;
      var scope = sticky.closest('section') || document;
      var add = scope.querySelector('[data-setosa-add]');
      if (!add) return;
      sticky.__setosaSticky = true;

      var stickyBtn = sticky.querySelector('[data-setosa-stickyadd]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () { add.click(); });

      /* Show the bar only once the buy button has scrolled away AND the
         shopper is scrolling up (heading back toward the buy area). Scrolling
         down, it stays hidden so it never fights the WhatsApp chat button. */
      var pastBuy = false, lastY = window.pageYOffset, up = false;
      function render() {
        var on = pastBuy && up;
        sticky.classList.toggle('is-show', on);
        document.documentElement.classList.toggle('setosa-sticky-on', on);
        liftChat(on ? sticky.offsetHeight : 0);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            pastBuy = !e.isIntersecting && e.boundingClientRect.top < 0;
            if (!pastBuy) up = false;
            render();
          });
        }, { threshold: 0 }).observe(add);
      }
      window.addEventListener('scroll', function () {
        var y = window.pageYOffset;
        if (Math.abs(y - lastY) < 6) return;
        up = y < lastY;
        lastY = y;
        render();
      }, { passive: true });
    });
  }

  /* Floating chat widgets (the Dondy WhatsApp app embed) are injected by the
     app, so we cannot restyle them from the theme. Find them by position and
     name, and lift them clear of the sticky bar while it is visible. */
  var chatEls = null;
  function liftChat(px) {
    if (chatEls === null) {
      chatEls = all('body *').filter(function (el) {
        var id = (el.id + ' ' + el.className).toString().toLowerCase();
        if (!/whatsapp|dondy|wa-float|wa-chat/.test(id) && !(el.matches && el.matches('a[href*="wa.me"],a[href*="api.whatsapp.com"]'))) return false;
        return getComputedStyle(el).position === 'fixed';
      });
      if (!chatEls.length) { var none = chatEls; chatEls = null; none.forEach(function () {}); return; }
    }
    chatEls.forEach(function (el) {
      el.style.transition = 'transform .3s ease';
      el.style.transform = px ? 'translateY(-' + (px + 8) + 'px)' : '';
    });
  }
  window.addEventListener('load', function () { chatEls = null; });

  /* ----------------------------------------------------------- scroll reveal */

  function initReveal() {
    var els = all('.setosa-reveal').filter(function (el) { return !el.__setosaReveal; });
    if (!els.length) return;
    els.forEach(function (el) { el.__setosaReveal = true; });
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------ boot */

  function boot() {
    initCountdowns();
    initCarousels();
    initQty();
    initVariants();
    initBuyWidgetReposition();
    initPacks();
    initQtyPrice();
    initSticky();
    initReveal();
  }

  function start() {
    boot();
    // Theme editor re-renders sections without a page load.
    document.addEventListener('shopify:section:load', boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
